<template>
  <section
    id="program-features"
    class="section-program-features section-content"
  >
    <div
      :class="[
        'title-wrapper',
        { 'fade-in': isEnteringSectionProgramFeatures },
      ]"
    >
      <img class="title-logo" :src="require('@/assets/images/logo.png')" />
      <h2 class="title-text fz-40 fz-mbl-32 fz-mbp-24 c-fff fw-700 lh-11">
        Program Features
      </h2>
    </div>

    <div class="section-program-features__content">
      <div
        :class="[
          'content-section professional-dashboard',
          { 'fade-in': isEnteringSectionProgramFeatures },
        ]"
      >
        <div class="content-section__pattern">
          <img
            src="~@/assets/images/section-program-features/professional-dashboard.png"
            alt="Professional Dashboard"
          />
        </div>
        <div class="content-section__text c-fff">
          <h3 class="fz-35-vw fz-mbl-30 fz-mbp-26">Professional Dashboard</h3>
          <p class="fz-20-vw fz-mbl-18">
            We offer partners a professional dashboard that allows real-time
            monitoring of their business. This dashboard provides access to
            comprehensive member details, interaction records, account changes,
            and game records. The system automatically calculates commissions
            based on this information.
          </p>
        </div>
      </div>
      <div
        :class="[
          'content-section competitive-promo-materials swap',
          { 'fade-in': isEnteringSectionProgramFeatures },
        ]"
      >
        <div class="content-section__pattern">
          <img
            src="~@/assets/images/section-program-features/competitive-promo-materials.png"
            alt="Competitive Promo Materials"
          />
        </div>
        <div class="content-section__text c-fff">
          <h3 class="fz-35-vw fz-mbl-30 fz-mbp-26">
            Competitive Promo Materials
          </h3>
          <p class="fz-20-vw fz-mbl-18">
            GANGA7 will offer a substantial array of advertising materials to
            support you in promoting products.
          </p>
        </div>
      </div>
      <div
        :class="[
          'content-section weekly-settle-earning',
          { 'fade-in': isEnteringSectionProgramFeatures },
        ]"
      >
        <div class="content-section__pattern">
          <img
            src="~@/assets/images/section-program-features/weekly-settle-earning.png"
            alt="Weekly Settle Earning"
          />
        </div>
        <div class="content-section__text c-fff">
          <h3 class="fz-35-vw fz-mbl-30 fz-mbp-26">Weekly Settle Earning</h3>
          <p class="fz-20-vw fz-mbl-18">
            Earnings are finalized on a weekly basis. The marketing manager at
            GANGA7 will process the salary for the preceding week before each
            Friday, utilizing the data available on your dashboard.
          </p>
        </div>
      </div>
      <div
        :class="[
          'content-section guidance-and-support swap',
          { 'fade-in': isEnteringSectionProgramFeatures },
        ]"
      >
        <div class="content-section__pattern">
          <img
            src="~@/assets/images/section-program-features/1on1-guidance-and-support.png"
            alt="1 on 1 Guidance and Support"
          />
        </div>
        <div class="content-section__text c-fff">
          <h3 class="fz-35-vw fz-mbl-30 fz-mbp-26">
            1 on 1 Guidance and Support
          </h3>
          <p class="fz-20-vw fz-mbl-18">
            We provide one-on-one assistance to share our extensive experience
            and knowledge, guiding you from the beginning. Your dedicated
            manager will assist you in developing an effective marketing
            strategy and address any challenges you may face.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    isEnteringSectionProgramFeatures: {
      type: Boolean,
    },
  },

  data() {
    return {};
  },
};
</script>

<style lang="scss">
.section-program-features {
  padding: 80px 5% 50px;

  .title-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;

    opacity: 0;
    transition: all 0.65s;

    &.fade-in {
      opacity: 1;
    }

    .title-logo {
      @include mq(dsk) {
        height: 42px;
        margin-right: 18px;
      }

      height: 24px;
      margin-right: 8px;
    }
  }

  &__content {
    width: 90%;
    max-width: 1200px;

    margin: 0 auto;
    padding: 80px 0 0 0;

    @include mq(mbl) {
      padding: 50px 0 0 0;
    }

    @include mq(mbp) {
      width: 95%;
    }

    .content-section {
      display: flex;
      width: 100%;

      opacity: 0;
      transform: translateY(100px);

      &.fade-in {
        opacity: 1;
        transform: translateY(0);
      }

      @include mq(mbp) {
        flex-direction: column;
        align-items: center;
        padding-bottom: 50px;
      }

      &.swap {
        .content-section__pattern {
          order: 2;
          padding-left: 7%;
          padding-right: 0;

          @include mq(mbp) {
            order: 0;
            padding: 0;
          }
        }
      }

      &__pattern {
        width: 30%;
        padding-right: 8%;

        @include mq(mbp) {
          width: 40%;
          padding-right: 0;
          margin-bottom: 30px;
        }

        img {
          width: 100%;
        }
      }

      &__text {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        justify-content: center;
        width: 70%;

        @include mq(mbp) {
          width: 100%;
        }

        h3 {
          letter-spacing: 1px;
          margin-bottom: 30px;
          line-height: 1;
          font-style: italic;

          @include mq(mbp) {
            width: 100%;
            text-align: center;
          }
        }

        p {
          letter-spacing: 1px;
          line-height: 1.3;

          @include mq(mbp) {
            width: 100%;
            text-align: center;
          }
        }
      }

      &.professional-dashboard {
        padding-bottom: 18px;

        transition: all 0.65s 0.5s;
      }

      &.competitive-promo-materials {
        padding-bottom: 52px;

        transition: all 0.65s 0.8s;
      }

      &.weekly-settle-earning {
        padding-bottom: 120px;

        transition: all 0.65s 1.1s;
      }

      &.guidance-and-support {
        transition: all 0.65s 1.4s;
      }
    }
  }
}
</style>
